<div class="tags-filter">
  <div class="mode-toggle">
    <button class="mode-btn" [class.active]="mode === 'include'" (click)="setMode('include')">Include</button>
    <button class="mode-btn exclude" [class.active]="mode === 'exclude'" (click)="setMode('exclude')">Exclude</button>
  </div>

  <div class="search-box">
    <input type="text" [(ngModel)]="searchText" placeholder="Search tags..." />
  </div>

  <div class="bulk-actions">
    <a (click)="selectAll()">Select All</a>
    <a (click)="deselectAll()">Deselect All</a>
    <span class="count" *ngIf="selectedTags.size > 0">{{ selectedTags.size }} selected</span>
  </div>

  <div class="tag-list">
    <div *ngFor="let tag of filteredTags" class="tag-item" (click)="toggleTag(tag)">
      <input type="checkbox" [checked]="isSelected(tag)" (click)="$event.preventDefault()" />
      <span>{{ tag }}</span>
    </div>
    <div class="no-results" *ngIf="filteredTags.length === 0 && searchText">No tags match "{{ searchText }}"</div>
    <div class="no-results" *ngIf="filteredTags.length === 0 && !searchText">No tags available</div>
  </div>
</div>
